import { API_ROUTES } from "./apiRoutes";
import api from "./axiosInstance";

export const getNotes = async (data) => {
  const res = await api.post(API_ROUTES.NOTES.LIST, data);
  return res.data;
};

export const createNotes = async (data) => {
  const res = await api.post(API_ROUTES.NOTES.CREATE, data);
  return res.data;
};
